import { Controller } from "@hotwired/stimulus";
import { initDropzone, initDropzoneBasicEvents } from "../../components/dropzone";

export default class extends Controller {
  static targets = ["filePreviewsContainer", "uploadImgLabel", "dragAndDropContainer"];

  connect() {
    this._initDropzone();
  }

  _initDropzone() {
    this.dropzone = initDropzone(this.element.id, {}, this._uploadOptions());
    initDropzoneBasicEvents(this.dropzone, this.uploadImgLabelTarget, this.dragAndDropContainerTarget);
  }

  _uploadOptions() {
    return {
      url: this.element.dataset.uploadMadelinStatementsUrl,
      previewsContainer: this.filePreviewsContainerTarget,
      clickable: this.dragAndDropContainerTarget,
    };
  }
}
